import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext } from 'react';
export const createSafeContext = (errorMessage) => {
    const Context = createContext(null);
    const useSafeContext = () => {
        const context = useContext(Context);
        if (context === null) {
            throw new Error(errorMessage);
        }
        return context;
    };
    const Provider = ({ children, value, }) => (_jsx(Context.Provider, { value: value, children: children }));
    return [Provider, useSafeContext];
};
